module.exports = __webpack_public_path__ + "src/assets/img/page7/ada28d5a85d00fbcf8fd1f9dd86f894d.png";